import { buildImageSrc } from '@repo/ui/src/functions/image-functions-aspect-ratio';
import { ToutContent } from '@repo/ui/src/components/ToutContent';
import { HeaderVariationProps } from '@repo/ui/src/types/headerVariation';
import { CurrentUrlProps } from '@repo/ui/src/types/currentUrl';
import { AmplienceButtonProps } from '@repo/ui/src/types/button';
import LazyLoadImage from '@repo/ui/src/components/LazyLoadImage';
import { ImageProps } from '@repo/ui/src/types/image';

type Align = 'left' | 'center' | 'right';

export interface TextContentColumnProps {
  heading: string;
  description: string;
  darkTheme: boolean;
  headerVariation: HeaderVariationProps;
  align: Align;
  currentUrl: CurrentUrlProps;
  button: AmplienceButtonProps;
  icon: ImageProps;
}

const TextContentColumn = ({
  heading,
  headerVariation,
  description,
  icon,
  align = 'left',
  darkTheme,
  button,
}: TextContentColumnProps) => {
  return (
    <div className="tw-p-4 md:tw-py-4">
      {icon?.image && (
        <div className="tw-w-8 tw-mb-5">
          <LazyLoadImage imgComponent={<img src={buildImageSrc(icon, 32, 1, 1)} alt="" />} />
        </div>
      )}
      {heading && (
        <ToutContent
          headingStyleVariant={headerVariation?.headerVariation}
          headerVariation={headerVariation}
          dark={darkTheme}
          className="[&_h2]:!tw-mt-5 [&_h2]:!tw-py-0"
          buttons={button ? (Array.isArray(button) ? button : [button]) : undefined}
          {...{ description, heading, align }}
        />
      )}
    </div>
  );
};

export default TextContentColumn;
